import RequestCache from "./RequestCache";

export default class Cities extends RequestCache {
    get link() {
        return this.links.cities;
    }

    get cacheInterval() {
        return 7;
    }
}
